import { RolePermission } from "../auth-types";

export interface ConfigCategory {
    title: string;
    items: Array<string>;
    permissionId?: RolePermission
};

export interface ConfigMap {
    defaultConfig: Array<ConfigCategory>;
    wzlrulConfig: Array<ConfigCategory>;
    _8920Config: Array<ConfigCategory>;
    openWrtConfig: Array<ConfigCategory>;
};

export interface WanItem {
    name: string;
    value: "PVC10" | "PVC11" | "PVC12" | "PVC13" | "PVC14" | "PVC15" | "PVC16";
    type: "LTE" | "EWAN" | "WirelessClient";
    node: "PVC10" | "PVC11" | "PVC12" | "PVC13" | "PVC14" | "PVC15" | "PVC16";
};

export enum OpenwrtNetworkMode {
    WCDMA_ONLY = '1',
    LTE_ONLY = '3',
    _5G_ONLY = '15',
    LTE_AND_5G = '19',
    AUTOMATIC = '21'
};

export enum OpenwrtProtocolType {
    IPV4 = '1',
    IPV6 = '2',
    IPV4_AND_IPV6 = '3'
};

export enum OpenwrtAuthenticationProtocol {
    NONE = '0',
    PAP = '1',
    CHAP = '2'
};

export enum OpenwrtNumberBoolean {
    NO = '0',
    YES = '1'
};

export enum OpenwrtConnectionMonitoringStatus {
    DISABLED = '0',
    ENABLE_WITH_MODEM_RECONNECT = '1'
};

export enum OpenwrtSpeedtestServerType {
    ID = 'ID',
    URL = 'URL'
};

export enum DualWanMode {
    DISABLED = 'disable',
    FAILOVER_AND_FAILBACK = "failover",
    FAILOVER_AND_PRIORITY = "failover_priority",
    LOAD_BALANCE = "loadbalance"
};

export enum DualWanKeepBackup {
    DISABLED = '0',
    ALWAYS = '1',
    BY_SIGNAL_STRENGTH = '2'
};

export enum DualWanProbeTargeType {
    GATEWAY = 'gateway',
    HOST = 'host'
};

export enum DualWanServiceDetection {
    ENABLE = 'Yes',
    DISABLE = 'No'
};

export interface SmartWiFiInterface {
    tag: string;
    name: string;
};

export enum DualWanLoadBalanceConnectMethod {
    BY_SESSION_ROUND_ROBIN = '1',
    BY_SESSION_WEIGHT = '2',
    BY_WEIGHT = '4',
};

export enum RadioActive {
    YES = 'Yes',
    NO = 'No'
};

export enum ProtocolBindingProtocol {
    ANY = 'ANY',
    TCP = 'TCP',
    UDP = 'UDP',
    ICMP = 'ICMP'
};

export enum CBSDCategory {
    A = "A",
    B = "B"
};

export enum IpsecIdType {
    DEFAULT = "0",
    DOMAIN = "1",
    EMAIL = "2",
    IPV4 = "3"
};

export enum PreSharedKeyFormat {
    TEXT = "Text",
    HEX = "Hex"
};

export enum EncryptionAlgorithm {
    DES = "0",
    _3DES = "1",
    AES128 = "2",
    AES192 = "3",
    AES256 = "4"
};

export enum AuthenticationAlgorithm {
    MD5 = "0",
    SHA1 = "1",
    SHA256 = "2"
};

export enum DhGroup {
    MODP1024 = "0",
    MODP1536 = "1",
    MODP2048 = "2",
    MODP3072 = "3",
    MODP4096 = "4"
};

export enum PfsGroup {
    NONE = "0",
    MODP1024 = "1",
    MODP1536 = "2",
    MODP2048 = "3",
    MODP3072 = "4",
    MODP4096 = "5"
};

export enum AuthenticationType {
    CHAP_PAP = "auto",
    PAP = "pap",
    CHAP = "chap",
    MS_CHAPv2 = "mschap"
};

export enum EncryptionKeyLength {
    AUTO = "auto",
    _40 = "40",
    _128 = "128",
};

export enum EncryptionMode {
    AUTO = "auto",
    STATELESS = "stateless"
};

export enum ConnectionType {
    REMOTE_ACCESS = "E0",
    LAN_TO_LAN = "E1"
};

export enum L2TPVersion {
    V2 = "v2",
    V3 = "v3"
};

export enum ConnectionMode {
    DIAL_IN = "dialin",
    DIAL_OUT = "dialout"
};

export enum L2TPAuthenticationType {
    CHAP_PAP = "chap",
    PAP = "pap"
};

export enum L2TPConnectionType {
    REMOTE_ACCESS = "remote access",
    LAN_TO_LAN = "lan to lan"
};

export enum IkeModeOptions {
    MAIN = "0",
    AGGRESSIVE = "1"
};

export enum L2TPIkeModeOptions {
    MAIN = "Main",
    AGGRESSIVE = "Aggr"
};

export enum V3EncapMode {
    IP = "ip",
    UDP = "udp",
};

export enum GreMode {
    TUN = "tun",
    TAP = "tap",
};

export enum OpenVpnTunnelType {
    TUN = "tun",
    TAP = "tap",
};

export enum OpenVpnTunnelProtocol {
    TCP = "tcp",
    UDP = "udp",
};

export enum Cipher {
    DEFAULT = "",
    BF_CBC = "BF-CBC",
    DES_CBC = "DES-CBC",
    DES_EDE3_CBC = "DES-EDE3-CBC",
    AES_128_CBC = "AES-128-CBC",
    AES_192_CBC = "AES-192-CBC",
    AES_256_CBC = "AES-256-CBC",
    NONE = "none",
};

export enum Hash {
    DEFAULT = "",
    MD5 = "MD5",
    SHA1 = "SHA1",
    SHA256 = "SHA256",
    SHA384 = "SHA384",
    SHA512 = "SHA512",
    NONE = "none"
};

export enum Compression {
    ADAPTIVE = "adaptive",
    NO = "no"
};

export enum WPAAlgorithm {
    TKIP = "TKIP",
    AES = "AES",
    TKIPAES = "TKIPAES"
};

export enum OpenwrtUsername {
    ROOT = "root",
    USER = "User"
};

export enum MultipleApn {
    SINGLE = "0",
    DUAL = "1",
    DUAL_FAILOVER = "MULT_APN_FO"
};

export enum Ipv6464xlatActive {
    ACTIVATED = 'Yes',
    DEACTIVATED = 'No'
};

export enum Ipv6464xlatDestinationAuto {
    AUTOMATICALLY = 'Yes',
    MANUALLY = 'No'
};